import React, { useState } from 'react';
import { sifreDegistir } from '../services/api';

export default function SifreDegistir() {
  const kullanici = JSON.parse(localStorage.getItem('kullanici') || '{}');

  const [eski, setEski] = useState('');
  const [yeni, setYeni] = useState('');
  const [tekrar, setTekrar] = useState('');
  const [mesaj, setMesaj] = useState('');
  const [hata, setHata] = useState('');
  const [gonderiliyor, setGonderiliyor] = useState(false);

  const kaydet = async (e) => {
    e.preventDefault();
    setHata(''); setMesaj('');

    if (yeni.length < 4) { setHata('Yeni şifre en az 4 karakter olmalıdır.'); return; }
    if (yeni !== tekrar) { setHata('Yeni şifre ile tekrarı eşleşmiyor.'); return; }

    setGonderiliyor(true);
    try {
      await sifreDegistir(kullanici.siteId, kullanici.noo, eski, yeni);
      setMesaj('Şifreniz başarıyla değiştirildi.');
      setEski(''); setYeni(''); setTekrar('');
    } catch (err) {
      setHata(err.response?.data?.mesaj || 'Şifre değiştirilemedi.');
    } finally {
      setGonderiliyor(false);
    }
  };

  return (
    <div>
      <h1 className="sayfa-baslik">Şifremi Değiştir</h1>
      <p className="sayfa-alt">Hesabınızın şifresini güncelleyin.</p>

      <div className="kart kart-pad" style={{ maxWidth: 420 }}>
        <form onSubmit={kaydet}>
          <div className="form-row" style={{ marginBottom: 14 }}>
            <div className="form-label">Mevcut Şifre</div>
            <input type="password" className="input" value={eski} onChange={e => setEski(e.target.value)}
                   required autoComplete="current-password" style={{ width: '100%' }} />
          </div>
          <div className="form-row" style={{ marginBottom: 14 }}>
            <div className="form-label">Yeni Şifre</div>
            <input type="password" className="input" value={yeni} onChange={e => setYeni(e.target.value)}
                   required autoComplete="new-password" style={{ width: '100%' }} />
          </div>
          <div className="form-row" style={{ marginBottom: 18 }}>
            <div className="form-label">Yeni Şifre (Tekrar)</div>
            <input type="password" className="input" value={tekrar} onChange={e => setTekrar(e.target.value)}
                   required autoComplete="new-password" style={{ width: '100%' }} />
          </div>

          {hata && (
            <div style={{ background: '#FCEBEB', color: '#A32D2D', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
              {hata}
            </div>
          )}
          {mesaj && (
            <div style={{ background: '#E9F9EF', color: '#1D7A46', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>
              {mesaj}
            </div>
          )}

          <button className="btn" type="submit" disabled={gonderiliyor}>
            {gonderiliyor ? 'Kaydediliyor…' : 'Şifreyi Değiştir'}
          </button>
        </form>
      </div>
    </div>
  );
}
